exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label {\n  font-weight: bold;\n  margin-top: .3rem; }\n\n.description {\n  font-size: 14px; }\n\nth, td {\n  border-top: none;\n  border-bottom: none;\n  padding: 1.3%;\n  text-align: center;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center; }\n\n.table thead th {\n  border: none !important; }\n\n.table {\n  border-collapse: unset; }\n\n.form-control {\n  text-align: center; }\n\n.total {\n  margin-top: .3rem; }\n\n.confirm {\n  font-weight: 500;\n  font-size: medium; }\n\n.confirm-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n.confirm-checkbox {\n  width: 15px;\n  height: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/cut-cable-modal/cut-cable-modal.component.scss
// module id = ../../../../../src/app/cut-cable-modal/cut-cable-modal.component.scss
// module chunks = main